import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import withErrorBoundary from '../ErrorBoundary';
import { UI_ASSIGN_SEAT_BUTTON } from '../_core/common/constants/ErrorBoundaryNames';
import * as tracker from '../_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties, trackPotentialBannerInteraction } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignSeatButton = ({
  upgradeData,
  level,
  usageLimitBannerData,
  use,
  'data-test-id': dataTestId = 'assign-seat-button',
  'data-selenium-id': dataSeleniumId,
  block
}) => {
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData)));
  }, [upgradeData, usageLimitBannerData, level]);
  const trackClick = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData)));
    tracker.track('interaction', Object.assign({
      action: 'clicked assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, getUpgradeDataTrackingProperties(upgradeData)));
    const {
      pointType,
      upgradeKey
    } = upgradeData;
    trackPotentialBannerInteraction(pointType, upgradeKey).catch(error => {
      Raven.captureException(new Error('Failed to submit interaction from UIAssignSeatButton'), {
        extra: {
          error
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": dataTestId,
    href: getPaidUserManagementUrl(),
    external: true,
    onClick: trackClick,
    use: use,
    "data-selenium-id": dataSeleniumId,
    block: block,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.assignSeatButton"
    })
  });
};
export default withErrorBoundary(AssignSeatButton, {
  boundaryName: UI_ASSIGN_SEAT_BUTTON
});